'use client';

import { useFieldContext } from '@/lib/form';
import { Label } from '@sapling/ui/components/ui/label';
import { Textarea } from '@sapling/ui/components/ui/textarea';
import { FieldError, fieldErrorId } from './field-error';

export function TextareaField({
  label,
  placeholder,
  rows = 4,
  optional,
}: {
  label: string;
  placeholder?: string;
  rows?: number;
  optional?: boolean;
}) {
  const field = useFieldContext<string>();
  const hasErrors =
    field.state.meta.isTouched && field.state.meta.errors.length > 0;

  return (
    <div>
      <Label htmlFor={field.name}>
        {label}
        {optional ? (
          <span className="text-neutral-400"> (valfritt)</span>
        ) : (
          ' *'
        )}
      </Label>
      <Textarea
        id={field.name}
        value={field.state.value}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        placeholder={placeholder}
        rows={rows}
        className="resize-y"
        aria-invalid={hasErrors}
        aria-describedby={hasErrors ? fieldErrorId(field.name) : undefined}
      />
      <FieldError errors={field.state.meta.errors} fieldName={field.name} />
    </div>
  );
}
